import { render, staticRenderFns } from "./welcomePage.vue?vue&type=template&id=0fa67786"
import script from "./welcomePage.vue?vue&type=script&lang=js"
export * from "./welcomePage.vue?vue&type=script&lang=js"
import style0 from "./welcomePage.vue?vue&type=style&index=0&id=0fa67786&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports